import { ComponentProps, FC } from 'react';
import {
  Button,
  Grid,
  GridItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Tooltip,
  Box,
} from '@chakra-ui/react';
import { useDetailStore } from '../../hooks';
import { CrawlerBaseInputModalView } from './CrawlerBaseInputModalView';
import { CrawlerDetailsModalView } from './CrawlerDetailsModalView';
import { CrawlerDetailConfirmModalView } from './CrawlerDetailConfirmModalView';
import { CrawlerDetailDeleteModalView } from './CrawlerDetailDeleteModalView';
import { CrawlerBaseConfirmModalView } from './CrawlerBaseConfirmModalView';

type Props = ReturnType<typeof useDetailStore> & {
  baseInputModalViewProps: ComponentProps<typeof CrawlerBaseInputModalView>;
  baseConfirmModalViewProps: ComponentProps<typeof CrawlerBaseConfirmModalView>;
  detailsModalViewProps: ComponentProps<typeof CrawlerDetailsModalView>;
  detailConfirmProps: ComponentProps<typeof CrawlerDetailConfirmModalView>;
  detailDeleteProps: ComponentProps<typeof CrawlerDetailDeleteModalView>;
};

export const CrawlerModalView: FC<Props> = ({
  baseInputModalViewProps,
  baseConfirmModalViewProps,
  detailsModalViewProps,
  detailConfirmProps,
  detailDeleteProps,
  isOpenModal,
  onCloseModalDetail,
  onOpenModalDelete,
  canDeleteCrawler,
}) => (
  <>
    <Modal
      isOpen={isOpenModal}
      onClose={onCloseModalDetail}
      size="5xl"
      blockScrollOnMount
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent maxHeight="90vh">
        <ModalHeader p="40px">クローラー更新</ModalHeader>
        <ModalCloseButton />
        <ModalBody overflowY="auto" px="40px">
          <Stack spacing="24px" direction="column">
            <CrawlerBaseInputModalView {...baseInputModalViewProps} />
            <CrawlerDetailsModalView {...detailsModalViewProps} />
          </Stack>
        </ModalBody>
        <ModalFooter p="40px">
          <Grid templateColumns="1fr repeat(1, auto) 1fr" w="full">
            <GridItem gridColumnStart="2">
              <Button
                w="140px"
                colorScheme="blackAlpha"
                variant="outline"
                onClick={onCloseModalDetail}
              >
                閉じる
              </Button>
            </GridItem>
            <GridItem ml="auto">
              <Tooltip
                label={
                  canDeleteCrawler
                    ? ''
                    : 'バージョンが存在するため削除できません'
                }
              >
                <Box>
                  <Button
                    colorScheme="red"
                    variant="ghost"
                    isDisabled={!canDeleteCrawler}
                    onClick={onOpenModalDelete}
                  >
                    このクローラーを削除
                  </Button>
                </Box>
              </Tooltip>
            </GridItem>
          </Grid>
        </ModalFooter>
      </ModalContent>
    </Modal>
    <CrawlerBaseConfirmModalView {...baseConfirmModalViewProps} />
    <CrawlerDetailConfirmModalView {...detailConfirmProps} />
    <CrawlerDetailDeleteModalView {...detailDeleteProps} />
  </>
);
